// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { Locale } from '@headless-workspace/config';
import { CommonDI, SearchRepositoryType } from '../../../DI';

export const getMemoPopularSearches = memoizedCache((locale: Locale) =>
    CommonDI.get(SearchRepositoryType).fetchPopular(locale),
);
